module.exports = __webpack_public_path__ + "bb408414.svg";